export enum PaymentKind {
  CRYPTO_ACCOUNT_REPLENISH = 'CRYPTO_ACCOUNT_REPLENISH',
  CRYPTO_ACCOUNT_WITHDRAW = 'CRYPTO_ACCOUNT_WITHDRAW',
  FIAT_WITHDRAW = 'FIAT_WITHDRAW',
  FIAT_REPLENISH = 'FIAT_REPLENISH',
  EXCHANGE_PAYMENT = 'EXCHANGE_PAYMENT',
  FIAT_INVOICE = 'FIAT_INVOICE',
  CRYPTO_INVOICE = 'CRYPTO_INVOICE',
  CRYPTO_ACCOUNT_TRANSFER_WITHDRAW = 'CRYPTO_ACCOUNT_TRANSFER_WITHDRAW',
  CRYPTO_ACCOUNT_TRANSFER_REPLENISH = 'CRYPTO_ACCOUNT_TRANSFER_REPLENISH',
  FIAT_ACCOUNT_TRANSFER_REPLENISH = 'FIAT_ACCOUNT_TRANSFER_REPLENISH',
  FIAT_ACCOUNT_TRANSFER_WITHDRAW = 'FIAT_ACCOUNT_TRANSFER_WITHDRAW',
  ROTATING_ADDRESS_REPLENISH = 'ROTATING_ADDRESS_REPLENISH'
}
